import styled from "styled-components";

interface IInputForm {
	hasError: boolean;
}

export const Form = styled.form`
	width: 92%;

	display: flex;
	align-items: flex-start;
	justify-content: center;

	flex-direction: column;

	margin-bottom: 24px;

	>p{
		font-size: 14px;
		color: ${props => props.theme.palette.greyscale.grey900};
	}

	span{
		font-size: 12px;
		color: ${props => props.theme.palette.greyscale.grey600};
	}

	>h3{
		color: #FF3838;
		margin-bottom: 18px;
	}

	>button{
		width: 100%;

		padding: 9px 24px;

		background: ${props => props.theme.palette.primary.blue400};
		border: 0;
		border-radius: 5px;

		font-size: 14px;	
		font-weight: 600;
		color: #FFF;

		cursor: pointer;
		transition: background-color 0.3s ease;

		&:hover:not(:disabled) {
			background-color: ${props => props.theme.palette.primary.blue500};
		}

		&:disabled {
			background-color: ${props => props.theme.palette.greyscale.grey300};
			cursor: not-allowed;
			opacity: 0.7;
		}
	}

	>label{
		width: 100%;

		background: #FFF;
		border: 2px solid ${props => props.theme.palette.primary.blue400};
		border-radius: 5px;

		padding: 9px 24px;

		font-size: 14px;
		font-weight: 600;
		color: ${props => props.theme.palette.primary.blue400};

		cursor: pointer;
		text-align: center;
		transition: all 0.3s ease;

		&:hover {
			background-color: ${props => props.theme.palette.primary.blue50};
		}
	}

	@media(max-width: ${props => props.theme.breakpoints.tablet}){
		width: 85%;

		>p{
			font-size: 13px;
		}

		>button{
			padding: 10px 24px;
			font-size: 12px;
		}

		>label{
			padding: 14px 24px;
			font-size: 12px;
		}
	}

	@media(min-width: ${props => props.theme.breakpoints.desktopTxl}){
		>p{
			font-size: 16px;
		}

		>button{
			padding: 10px 24px;
			font-size: 15px;
		}

		>label{
			padding: 10px 24px;
			font-size: 15px;
		}
	}
`;

export const InputForm = styled.input<IInputForm>`
	width: 100%;

	padding: 8px;

	border: 0;
	border-bottom: ${props => !!props.hasError
		? "2px solid #FF3838"
		: `1px solid ${props.theme.palette.greyscale.grey200}`};

	margin-bottom: 24px;

	background: transparent;

	font-size: 14px;
	color: ${props => props.theme.palette.greyscale.grey900};

	&:focus {
		outline: none;
		border-bottom-color: ${props => !!props.hasError
		? "#FF3838"
		: props.theme.palette.primary.blue500};
	}

	@media(min-width: ${props => props.theme.breakpoints.desktopTxl}){
		margin-bottom: 42px;
	}
`;

export const OthersLoginOptions = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	width: 92%;

	.kep-login-facebook.metro {
	    border-radius: 5px;

	    >svg{
			margin-left: 35%;
	    	margin-right: 8px;
	    }
	}

	>span{
		width: 100%;
	}

	button{
		display: flex;
		align-items: center;
		justify-content: flex-start;

		font-size: 14px;
		font-weight: 600;
		color: ${props => props.theme.palette.greyscale.grey500};

		padding: 2px 18px;

		background: transparent;

		border: 1px solid ${props => props.theme.palette.greyscale.grey200};
		border-radius: 5px;

		width: 100%;

		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			background-color: ${props => props.theme.palette.greyscale.grey50};
			border-color: ${props => props.theme.palette.greyscale.grey300};
		}

		>p{
			margin: 0 auto;
			font-size: 15px;
		}

		& + span{
			margin-left: auto;
		}
	}

	@media(max-width: ${props => props.theme.breakpoints.tablet}){
		width: 85%;

		.kep-login-facebook.metro {
		    >svg{
		    	margin-right: 8px;
		    }
		}

		button{
			padding: 8px 18px;
			font-size: 12px;
			width: 100%;

			>svg{
				width: 15px;
				height: 15px;
			}

			>p{
				font-size: 9px;
			}
		}
	}

	@media(min-width: ${props => props.theme.breakpoints.desktopTxl}){
		button{
			font-size: 12px;
		}
	}
`;

export const SocialButtonsContainer = styled.div`
	width: 92%;
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-bottom: 24px;

	@media(max-width: ${props => props.theme.breakpoints.tablet}){
		width: 85%;
		gap: 10px;
	}

	@media(min-width: ${props => props.theme.breakpoints.desktopTxl}){
		gap: 14px;
		margin-bottom: 28px;
	}
`;

export const Divider = styled.div`
	width: 92%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 24px 0;
	color: ${props => props.theme.palette.greyscale.grey500};
	font-size: 12px;
	font-weight: 600;

	&::before,
	&::after {
		content: '';
		flex: 1;
		height: 1px;
		background: ${props => props.theme.palette.greyscale.grey200};
	}

	&::before {
		margin-right: 12px;
	}

	&::after {
		margin-left: 12px;
	}

	@media(max-width: ${props => props.theme.breakpoints.tablet}){
		width: 85%;
		font-size: 11px;
		margin: 20px 0;

		&::before {
			margin-right: 10px;
		}

		&::after {
			margin-left: 10px;
		}
	}

	@media(min-width: ${props => props.theme.breakpoints.desktopTxl}){
		font-size: 14px;
		margin: 28px 0;
	}
`;